exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pjax-loader-bar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999999;\n  opacity: 0;\n}\n.pjax-loader-bar .progress {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 2px;\n  background: #77b6ff;\n  box-shadow: 0 0 10px rgba(119, 182, 255, 0.7);\n  -webkit-transition: width 0.2s ;\n  transition: width 0.2s ;\n}\n.pjax-loader-bar.is-loading {\n  opacity: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./example/app/common/loadingbar/loadingbar.less
// module id = 77
// module chunks = 40